import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        data-testid="protected-route-loading"
        className="min-h-screen bg-[#F2EBDC] flex items-center justify-center"
      >
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#0A0A0A]/60">
          Checking session…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
